import React, { useState, useContext, useEffect } from 'react';
import { TextField, Button, Paper, Typography, MenuItem, InputLabel, Grid, FormControl, Select, Box, IconButton, Stack } from '@mui/material';
import { isEmpty } from 'lodash';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import PhotoCameraRoundedIcon from '@mui/icons-material/PhotoCameraRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import ZoomInRoundedIcon from '@mui/icons-material/ZoomInRounded';

import { getToken } from '../../../api/Account';
import { DataContext } from '../../../context/DataContext';
import { getCommunitiesByMunAsync, getMunicipalitiesByDeptopAsync, getOnlyDepartmentListAsync } from '../../../api/Locations';
import { simpleMessage, validateCedula } from '../../../helpers/Helpers';

import { getClientByIdAsync, updateClientAsync } from '../../../api/Clients';
import { getSucursalByUserAsync } from '../../../api/Users';
import SmallModal from '../../../components/modals/SmallModal';
import ClientPhoto from './photoComponent/ClientPhoto';
import PreviewModal from '../../../components/modals/PreviewModal';

const CardHeader = ({ icon, title, action }) => (
	<Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="space-between" spacing={1} sx={{ marginBottom: '16px' }}>
		<Stack direction="row" spacing={1} alignItems="center">
			<Box sx={{ display: 'flex', color: 'success.main', fontSize: 19 }}>{icon}</Box>
			<Typography sx={{ fontSize: 14, fontWeight: 600 }}>{title}</Typography>
		</Stack>
		{action}
	</Stack>
);

const ClientDetails = ({ id, setClientName, setPromedio }) => {
	const token = getToken();

	const [departmentList, setDepartmentList] = useState([]);
	const [selectedDepartment, setselectedDepartment] = useState('');

	const [MunicipalitiesList, setMunicipalitiesList] = useState([]);
	const [selectedMunicipality, setselectedMunicipality] = useState('');

	const [communitiesList, setCommunitiesList] = useState([]);
	const [selectedCommunity, setselectedCommunity] = useState('');

	const [firstName, setFirstName] = useState('');
	const [secondName, setSecondName] = useState('');
	const [lastName, setLastName] = useState('');
	const [secondLastName, setSecondLastName] = useState('');
	const [identification, setIdentification] = useState('');
	const [phone, setPhone] = useState('');

	const [sex, setSex] = useState('');
	const [civilStatus, setCivilStatus] = useState('');

	const [address, setAddress] = useState('');

	const [company, setCompany] = useState('');
	const [companyAddress, setCompanyAddress] = useState('');

	const [actividadEconomica, setActividadEconomica] = useState('');

	const [sucursalList, setSucursalList] = useState([]);
	const [selectedSucursal, setSelectedSucursal] = useState(1);

	const [clientPhotos, setClientPhotos] = useState([]);

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const [isEdit, setIsEdit] = useState(false);

	const [editPhotos, setEditPhotos] = useState(false);
	const [localReload, setLocalReload] = useState(false);

	const [openModal, setOpenModal] = useState(false);
	const [selectedImage, setSelectedImage] = useState('');

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getClientByIdAsync(token, id);

			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}

			const resultDepto = await getOnlyDepartmentListAsync(token);

			if (!resultDepto.statusResponse) {
				setIsLoading(false);
				if (resultDepto.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(resultDepto.error, 'error');
				return;
			}

			setDepartmentList(resultDepto.data.result);

			const resultMun = await getMunicipalitiesByDeptopAsync(token, result.data.result.community.municipality.department.id);
			if (!resultMun.statusResponse) {
				setIsLoading(false);
				if (resultMun.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(resultMun.error, 'error');
				return;
			}
			setMunicipalitiesList(resultMun.data.result);

			const resultComm = await getCommunitiesByMunAsync(token, result.data.result.community.municipality.id);
			if (!resultComm.statusResponse) {
				setIsLoading(false);
				if (resultComm.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(resultComm.error, 'error');
				return;
			}
			getSucursals(token);

			setCommunitiesList(resultComm.data.result);
			setPromedio(result.data.result.promedio.toFixed(2));
			setClientName(result.data.result.fullName);

			setFirstName(result.data.result.firstName);
			setSecondName(result.data.result.secondName);
			setLastName(result.data.result.lastName);
			setSecondLastName(result.data.result.secondLastName);
			setPhone(result.data.result.phone);
			setIdentification(result.data.result.identification);
			setSex(result.data.result.sex === 'MASCULINO' ? 0 : 1);
			setCivilStatus(getCivilStatus(result.data.result.civilStatus));

			setselectedDepartment(result.data.result.community.municipality.department.id);
			setselectedMunicipality(result.data.result.community.municipality.id);
			setselectedCommunity(result.data.result.community.id);
			setAddress(result.data.result.address);

			setActividadEconomica(result.data.result.actividadEconomica);
			setCompany(result.data.result.company);
			setCompanyAddress(result.data.result.companyAddress);
			setSelectedSucursal(result.data.result.sucursal.id);
			setClientPhotos(result.data.result.clientPhotos);

			setIsLoading(false);
		})();
	}, [localReload]);

	const handleChangeSex = (event) => {
		setSex(event.target.value);
	};

	const handleChangeCivilStatus = (event) => {
		setCivilStatus(event.target.value);
	};

	const getCivilStatus = (data) => {
		if (data === 'SOLTERO' || data === 'SOLTERA') {
			return 0;
		} else if (data === 'CASADO' || data === 'CASADA') {
			return 1;
		} else {
			return 2;
		}
	};

	const handleChangeDepartment = async (event) => {
		setMunicipalitiesList([]);
		setCommunitiesList([]);
		setselectedDepartment(event.target.value);

		if (event.target.value !== '') {
			const result = await getMunicipalitiesByDeptopAsync(token, event.target.value);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setMunicipalitiesList(result.data.result);
		} else {
			setMunicipalitiesList([]);
		}
	};

	const handleChangeMunicipality = async (event) => {
		setCommunitiesList([]);
		setselectedMunicipality(event.target.value);

		if (event.target.value !== '') {
			const result = await getCommunitiesByMunAsync(token, event.target.value);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setCommunitiesList(result.data.result);
		} else {
			setCommunitiesList([]);
		}
	};

	const handleChangeComunity = (event) => {
		setselectedCommunity(event.target.value);
	};

	const getSucursals = async () => {
		setIsLoading(true);
		const result = await getSucursalByUserAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		setSucursalList(result.data.result);
	};

	const saveChanges = async () => {
		if (validate()) {
			const datos = {
				id,
				firstName: firstName,
				secondName: secondName,
				lastName: lastName,
				secondLastName: secondLastName,
				identification: identification,
				phone: phone,
				sex: sex === 0 ? 'MASCULINO' : 'FEMENINO',
				civilStatus: civilStatus === 0 ? (sex === 0 ? 'SOLTERO' : 'SOLTERA') : civilStatus === 1 ? (sex === 0 ? 'CASADO' : 'CASADA') : 'UNION LIBRE',
				idCommunity: selectedCommunity,
				address: address,
				company: company,
				companyAddress: companyAddress,
				actividadEconomica: actividadEconomica,
				sucursalId: selectedSucursal
			};

			setIsLoading(true);
			const result = await updateClientAsync(token, datos);
			if (!result.statusResponse) {
				setIsLoading(false);

				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}

				simpleMessage(result.error, 'error');
				return;
			}

			setIsLoading(false);
			setIsEdit(false);
			simpleMessage('Cliente actualizado...!', 'success');
		}
	};

	const validate = () => {
		let isValid = true;
		if (isEmpty(firstName)) {
			simpleMessage('Debe ingresar un nombre', 'error');
			return (isValid = false);
		}

		if (isEmpty(identification)) {
			simpleMessage('Debe ingresar una cedula', 'error');
			return (isValid = false);
		}

		if (!validateCedula(identification)) {
			simpleMessage('Debe ingresar una cedula valida', 'error');
			return (isValid = false);
		}

		if (isEmpty(phone)) {
			simpleMessage('Debe ingresar un telefono', 'error');
			return (isValid = false);
		}

		if (sex === '') {
			simpleMessage('Debe seleccionar un sexo', 'error');
			return (isValid = false);
		}

		if (civilStatus === '') {
			simpleMessage('Debe seleccionar un estado civil', 'error');
			return (isValid = false);
		}

		if (selectedCommunity === '') {
			simpleMessage('Debe seleccionar una comunidad', 'error');
			return (isValid = false);
		}

		if (isEmpty(address)) {
			simpleMessage('error', 'Debe ingresar una direccion', 'error');
			return (isValid = false);
		}

		if (isEmpty(actividadEconomica)) {
			simpleMessage('Debe ingresar una actividad economica', 'error');
			return (isValid = false);
		}
		return isValid;
	};

	const handleOpen = (imageUrl) => {
		setSelectedImage(imageUrl);
		setOpenModal(true);
	};

	return (
		<div>
			<Stack spacing={1.75}>
				<Paper sx={{ padding: '20px 22px' }}>
					<CardHeader
						icon={<PersonRoundedIcon fontSize="inherit" />}
						title="Datos del cliente"
						action={
							<Button onClick={() => setIsEdit(!isEdit)} variant="outlined" color="warning" size="small" startIcon={<EditRoundedIcon sx={{ fontSize: 17 }} />}>
								Editar
							</Button>
						}
					/>

					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<Stack spacing={2}>
								<TextField required fullWidth onChange={(e) => setFirstName(e.target.value.toUpperCase())} value={firstName} label={'Primer Nombre'} disabled={!isEdit} />
								<TextField fullWidth onChange={(e) => setSecondName(e.target.value.toUpperCase())} value={secondName} label={'Segundo Nombre'} disabled={!isEdit} />
								<TextField required fullWidth onChange={(e) => setLastName(e.target.value.toUpperCase())} value={lastName} label={'Primer apellido'} disabled={!isEdit} />
								<TextField fullWidth onChange={(e) => setSecondLastName(e.target.value.toUpperCase())} value={secondLastName} label={'Segundo Apellido'} disabled={!isEdit} />
							</Stack>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Stack spacing={2}>
								<TextField fullWidth required onChange={(e) => setPhone(e.target.value.toUpperCase())} value={phone} label={'Telefono'} disabled={!isEdit} />
								<TextField required fullWidth onChange={(e) => setIdentification(e.target.value.toUpperCase())} value={identification} label={'Cedula: 000-000000-0000X'} disabled={!isEdit} />
								<FormControl fullWidth disabled={!isEdit} style={{ textAlign: 'left' }}>
									<InputLabel id="demo-simple-select-standard-label">Sexo</InputLabel>
									<Select labelId="demo-simple-select-standard-label" onChange={handleChangeSex} value={sex} label="Municipio">
										<MenuItem value={0}>MASCULINO</MenuItem>
										<MenuItem value={1}>FEMENINO</MenuItem>
									</Select>
								</FormControl>

								<FormControl disabled={!isEdit} fullWidth style={{ textAlign: 'left' }}>
									<InputLabel id="demo-simple-select-standard-label">Estado Civil</InputLabel>
									<Select labelId="demo-simple-select-standard-label" onChange={handleChangeCivilStatus} value={civilStatus} label="Estado Civil">
										<MenuItem value={0}>{sex === 0 ? 'SOLTERO' : 'SOLTERA'}</MenuItem>
										<MenuItem value={1}>{sex === 0 ? 'CASADO' : 'CASADA'}</MenuItem>
										<MenuItem value={2}>UNION LIBRE</MenuItem>
									</Select>
								</FormControl>
							</Stack>
						</Grid>
					</Grid>
				</Paper>

				<Paper sx={{ padding: '20px 22px' }}>
					<CardHeader icon={<LocationOnRoundedIcon fontSize="inherit" />} title="Ubicación del cliente" />
					<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2}>
						<FormControl disabled={!isEdit} fullWidth required>
							<InputLabel id="demo-simple-select-standard-label">Departamento</InputLabel>
							<Select labelId="demo-simple-select-standard-label" value={selectedDepartment} onChange={handleChangeDepartment} label="Departamento" style={{ textAlign: 'left' }}>
								<MenuItem value="">
									<em>Seleccione un Departamento</em>
								</MenuItem>
								{departmentList.map((item) => (
									<MenuItem key={item.id} value={item.id}>
										{item.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>

						<FormControl disabled={!isEdit} fullWidth required>
							<InputLabel id="demo-simple-select-standard-label">Municipio</InputLabel>
							<Select labelId="demo-simple-select-standard-label" value={selectedMunicipality} onChange={handleChangeMunicipality} label="Municipio" style={{ textAlign: 'left' }}>
								<MenuItem value="">
									<em>Seleccione un Municipio</em>
								</MenuItem>
								{MunicipalitiesList.map((item) => (
									<MenuItem key={item.id} value={item.id}>
										{item.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>

						<FormControl disabled={!isEdit} fullWidth required>
							<InputLabel id="demo-simple-select-standard-label">Comunidad</InputLabel>
							<Select labelId="demo-simple-select-standard-label" value={selectedCommunity} onChange={handleChangeComunity} label="Comunidad" style={{ textAlign: 'left' }}>
								<MenuItem value="">
									<em>Seleccione una Comunidad</em>
								</MenuItem>
								{communitiesList.map((item) => (
									<MenuItem key={item.id} value={item.id}>
										{item.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Stack>

					<TextField
						required
						fullWidth
						multiline
						onChange={(e) => setAddress(e.target.value.toUpperCase())}
						sx={{ marginTop: '16px' }}
						value={address}
						label={'Direccion'}
						disabled={!isEdit}
					/>
				</Paper>

				<Paper sx={{ padding: '20px 22px' }}>
					<CardHeader icon={<WorkRoundedIcon fontSize="inherit" />} title="Actividad económica" />
					<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2}>
						<TextField required fullWidth onChange={(e) => setActividadEconomica(e.target.value.toUpperCase())} value={actividadEconomica} label={'Actividad Economica'} disabled={!isEdit} />
						<TextField required fullWidth onChange={(e) => setCompany(e.target.value.toUpperCase())} value={company} label={'Negocio o Centro de trabajo'} disabled={!isEdit} />
					</Stack>

					<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2} sx={{ marginTop: '16px' }}>
						<TextField required fullWidth multiline onChange={(e) => setCompanyAddress(e.target.value.toUpperCase())} value={companyAddress} label={'Direccion de trabajo'} disabled={!isEdit} />
						<FormControl fullWidth style={{ textAlign: 'left' }}>
							<InputLabel id="demo-simple-select-standard-label">Sucursal</InputLabel>
							<Select labelId="demo-simple-select-standard-label" onChange={(e) => setSelectedSucursal(e.target.value)} value={selectedSucursal} label="Sucursal" disabled={!isEdit}>
								{sucursalList.map((item) => (
									<MenuItem key={item.id} value={item.id}>
										{item.description}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Stack>
				</Paper>

				<Paper sx={{ padding: '20px 22px' }}>
					<CardHeader
						icon={<PhotoCameraRoundedIcon fontSize="inherit" />}
						title="Fotos del cliente"
						action={
							<Button onClick={() => setEditPhotos(true)} variant="outlined" color="warning" size="small" startIcon={<PhotoCameraRoundedIcon sx={{ fontSize: 17 }} />} disabled={!isEdit}>
								Cambiar fotos
							</Button>
						}
					/>

					<Grid container spacing={1.5}>
						{clientPhotos.map((preview, index) => (
							<Grid item xs={6} sm={4} key={index}>
								<Box
									sx={{
										position: 'relative',
										borderRadius: '11px',
										border: '1px solid',
										borderColor: 'divider',
										height: 160,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										overflow: 'hidden',
										backgroundColor: 'background.default'
									}}
								>
									<img src={preview.imageFullPath} alt={`Vista previa ${index + 1}`} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />

									<IconButton
										sx={{
											position: 'absolute',
											top: 8,
											right: 8,
											backgroundColor: 'rgba(0,0,0,.35)',
											color: '#fff',
											'&:hover': { backgroundColor: 'rgba(0,0,0,.55)' },
											width: 32,
											height: 32
										}}
										onClick={() => handleOpen(preview.imageFullPath)}
									>
										<ZoomInRoundedIcon sx={{ fontSize: 18 }} />
									</IconButton>
								</Box>
							</Grid>
						))}
					</Grid>
				</Paper>

				<Button variant="contained" color="primary" startIcon={<SaveRoundedIcon />} fullWidth onClick={() => saveChanges()} sx={{ padding: '12px' }} disabled={!isEdit}>
					Guardar cambios
				</Button>
			</Stack>

			<SmallModal titulo={'Editar Fotos'} isVisible={editPhotos} setVisible={setEditPhotos}>
				<ClientPhoto id={id} localReload={localReload} setLocalReload={setLocalReload} clientPhotos={clientPhotos} setEditPhotos={setEditPhotos} />
			</SmallModal>

			<PreviewModal openModal={openModal} selectedImage={selectedImage} setOpenModal={setOpenModal} setSelectedImage={setSelectedImage} />
		</div>
	);
};

export default ClientDetails;
